import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Report from "@/pages/Report";
import TrialReport from "@/pages/TrialReport";

export default function ReportAccessGate() {
  const { sessionId } = useParams();
  const [state, setState] = useState({ loading: true, freeTrial: false, failed: false });

  useEffect(() => {
    let alive = true;
    api.get(`/sessions/${sessionId}/access-summary`)
      .then(({ data }) => {
        if (!alive) return;
        setState({ loading: false, freeTrial: Boolean(data?.free_trial), failed: false });
      })
      .catch(() => {
        if (!alive) return;
        setState({ loading: false, freeTrial: false, failed: true });
      });
    return () => { alive = false; };
  }, [sessionId]);

  if (state.loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-sm text-[color:var(--text-secondary)]">Loading…</div>;
  }
  if (state.freeTrial) {
    return <TrialReport />;
  }
  if (state.failed) {
    return <Navigate to="/" replace />;
  }
  return <Report />;
}
